const mapTutorial = {
  module: 'map',
  moduleName: 'Site Map',
  steps: [
    { target: '.page-title', position: 'bottom', title: 'Site Map', description: 'Visualize your cameras, doors, and devices on floor plans.' },
    { target: '.page-header-actions .btn-primary', position: 'bottom', title: 'New Survey', description: 'Create a new floor plan with the site survey wizard.' },
  ],
};
export default mapTutorial;
